import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    selectobj:"",
    isMD:false,//是否是门店配送页面
    tableNum:false,
    btnlist:sessionStorage.getItem('modulelist') || undefined,//辅助功能
    isPenetrate:false,
    webConfig: {
      type:2, // 环境 1测试环境，2生产环境
      dataOne: {
        // requestUrl: 'http://knywaw.88933.vip:10044', // 请求地址 远程外网 丽刚
        // requestUrl: 'http://zyy123321.gnway.cc:80', // 请求地址 远程外网 阳
        // requestUrl: 'http://125.46.96.247:8020', // 请求地址 汴卫
        // requestUrl: 'http://116.63.163.202:8020', // 请求地址 线上
        // requestUrl: 'http://192.168.1.8:7995', // 请求地址 线上
        // requestUrl: 'http://39.164.68.159:9025', // 请求地址 能健

        // requestUrl: 'http://192.168.1.136:8081', // 请求地址 本地               王哥儿
        // requestUrl: 'http://192.168.1.138:8081', // 请求地址 本地            阳总
        requestUrl: 'http://192.168.1.112:8081', // 请求地址 本地            敬毓
        chatUrl: "http:/192.168.1.103:8081", //聊天服务地址
        // chatUrl: "http:/192.168.1.129:8081", //聊天服务地址
        // requestUrl: 'http://61.168.3.146:8020', // 请求地址 嵩韵 dfsoft 123456
        imgUrl: 'http://192.168.1.129:8033', // 图片地址 汴卫
        // imgUrl: 'http://192.168.1.8:8029', // 图片地址 汴卫
        // TMSrequestUrl: 'http://116.63.163.202:8180' ,// 请求地址TMS
        TMSrequestUrl: 'http://192.168.1.105:8010' ,// 请求地址TMS      阳阳
        TMSimgUrl: 'http://192.168.1.105:85', // 图片地址TMS            阳阳
        // TMSimgUrl: 'http://116.63.163.202:8022', // 图片地址TMS
      },
      // 生产环境
      dataTwo: {
        // requestUrl: 'http://116.63.163.202:8020',  +--------*// 请求地址
        // imgUrl: 'http://116.63.163.202:8022',      // 图片地址
        TMSrequestUrl: window.global_config.TMS_URL, // 请求地址TMS
        TMSimgUrl: window.global_config.TMS_IMG_URL, // 图片地址TMS
        requestUrl: window.global_config.BASE_URL, // 请求地址
        imgUrl: window.global_config.BASE_IMG_URL, // 图片地址
        chatUrl: window.global_config.CHAT_UR
      },
    },
    // 全局 input 输入的位数
    inputLength: 500,
    // 登录页图片轮播
    bannerList: [
      { id: 0, url: '/img/banner_1.png' },
      { id: 1, url: '/img/banner_2.png' },
      { id: 2, url: '/img/banner_3.png' },
    ],
    // 用户缓存
    userInfo: sessionStorage.getItem('userInfo') || false,
    token: '',
    // 已经处理过的树形菜单
    menuList: sessionStorage.getItem('webMenuList') || false,
    // 未处理的所有菜单
    allMenuList: sessionStorage.getItem('allWebMenuList') || false,

    // 权限类型
    jurisdictionType: [
      { id: 0, name: '功能模块' },
      { id: 1, name: '单元管理' },
      { id: 2, name: '单元下属' },
      { id: 3, name: '具体操作' },
    ],
    // 是否首页单元
    jurisdictionHome: [
      { id: 0, name: '隐藏' },
      { id: 1, name: '展示' },
    ],
    // 组织状态
    organizationStatus: [
      { id: 0, name: '停用' },
      { id: 1, name: '启用' },
    ],
    // 部门状态
    departmentStatus: [
      { id: 0, name: '停用' },
      { id: 1, name: '启用' },
    ],
    // 用户性别
    userSex: [
      { id: 0, name: '男' },
      { id: 1, name: '女' },
    ],
    // 人员状态
    userStatus: [
      { id: 0, name: '停用' },
      { id: 1, name: '启用' },
    ],
    // 车辆状态
    carStatus: [
      { id: 0, name: '停用' },
      { id: 1, name: '启用' },
    ],
    businessGoodsState: [
      { id: 0, name: '停用' },
      { id: 1, name: '正常' },
      { id: 2, name: '停止采购' },
      { id: 3, name: '停止销售' },
    ],
    purchaseReturnState: [
      { id: 0, name: '待提交' },
      { id: 1, name: '待审核' },
      { id: 2, name: '审核通过' },
      { id: 3, name: '审核驳回' },
    ],
    // 销售退补价状态
    salesReturnCompensateState: [
      { id: 0, name: '初始' },
      { id: 1, name: '提交审核' },
      { id: 2, name: '审核通过' },
      { id: 3, name: '审核退回' },
    ],
    // 权限申请状态
    gpmState: [
      { id: 0, name: '初始' },
      { id: 1, name: '提交审核' },
      { id: 2, name: '审核通过' },
      { id: 3, name: '审核退回' },
    ],
    // 不合格登记状态
    unqualifiedRegister: [
      { id: -1, name: '审核退回' },
      { id: 0, name: '初始' },
      { id: 1, name: '提交审核' },
      { id: 2, name: '审核通过' },
      { id: 3, name: '已被提取' },
    ],
    unqualifiedRegister: {
      '-1': '审核退回',
      '0': '初始',
    },
    // 采购订单状态
    purchaseOrderState: [
      { id: 0, name: '初始' },
      { id: 1, name: '审核退回' },
      { id: 2, name: '提交审核' },
      { id: 3, name: '审核通过' },
      { id: 4, name: '订单关闭' },
      { id: 5, name: '收货完成' },
    ],
    // 采购订单明细状态
    purchaseOrderDetailsState: [
      { id: 0, name: '初始' },
      { id: 1, name: '关闭' },
      { id: 2, name: '收货完成' },
    ],
    // 资料变更类型
    dataChangeType: [
      { id: 0, name: '商品' },
      { id: 1, name: '供货商' },
      { id: 2, name: '客户' },
    ],
    // 资料变更类型(新)
    dataChangeTypeX: [
      { id: 0, name: '商品' },
      { id: 1, name: '供货商' },
      { id: 2, name: '客户' },
      { id: 3, name: '委托书' },
    ],
    // 库存报损发起类型
    lomApptype: [
      { id: 0, name: '手动发起' },
      { id: 1, name: '库存盘点' },
    ],
    // 库存报溢发起类型
    ovmApptype: [
      { id: 0, name: '手动发起' },
      { id: 1, name: '库存盘点' },
    ],
    // 对方人员类型
    unitUserType: [
      { id: 0, name: '客户' },
      { id: 1, name: '供应商' },
    ],
    // 对方人员类别
    unitUserCate: [
      { id: 0, name: '业务员' },
      { id: 1, name: '提货员' },
      { id: 2, name: '收货员' },
    ],
    // 单位是否拦截
    unitIsIntercept: [
      { id: 0, name: '否' },
      { id: 1, name: '是' },
    ],
    // 委托书类别
    entrustBookCate: [
      { id: 0, name: '采购委托书' },
      { id: 1, name: '提货委托书' },
      { id: 2, name: '收货委托书' },
    ],
    // 委托书类型
    entrustBookType: [
      { id: 0, name: '单品' },
      { id: 1, name: '全品' },
    ],
    //头部任务
    webIndexHeaderCount: 0,
    // 预警页面参数
    webIndexEarlyWarningData: '',
    // isWarn: false
    // 权限类型
    jurisdictionType: [
      { id: 0, name: '功能模块' },
      { id: 1, name: '单元管理' },
      { id: 2, name: '单元下属' },
      { id: 3, name: '具体操作' }
    ],
    // 是否首页单元
    jurisdictionHome: [
      { id: 0, name: '隐藏' },
      { id: 1, name: '展示' }
    ],
    // 组织状态
    organizationStatus: [
      { id: 0, name: '停用' },
      { id: 1, name: '启用' }
    ],
    // 部门状态
    departmentStatus: [
      { id: 0, name: '停用' },
      { id: 1, name: '启用' }
    ],
    // 用户性别
    userSex: [
      { id: 0, name: '男' },
      { id: 1, name: '女' }
    ],
    // 人员状态
    userStatus: [
      { id: 0, name: '停用' },
      { id: 1, name: '启用' }
    ],
    // 车辆状态
    carStatus: [
      { id: 0, name: '停用' },
      { id: 1, name: '启用' }
    ],
    businessGoodsState: [
      { id: 0, name: '停用' },
      { id: 1, name: '正常' },
      { id: 2, name: '停止采购' },
      { id: 3, name: '停止销售' }
    ],
    purchaseReturnState: [
      { id: 0, name: '待提交' },
      { id: 1, name: '待审核' },
      { id: 2, name: '审核通过' },
      { id: 3, name: '审核驳回' }
    ],
    // 销售退补价状态
    salesReturnCompensateState: [
      { id: 0, name: '初始' },
      { id: 1, name: '提交审核' },
      { id: 2, name: '审核通过' },
      { id: 3, name: '审核退回' }
    ],
    // 权限申请状态
    gpmState: [
      { id: 0, name: '初始' },
      { id: 1, name: '提交审核' },
      { id: 2, name: '审核通过' },
      { id: 3, name: '审核退回' }
    ],
    // 不合格登记状态
    unqualifiedRegister: [
      { id: -1, name: '审核退回' },
      { id: 0, name: '初始' },
      { id: 1, name: '提交审核' },
      { id: 2, name: '审核通过' },
      { id: 3, name: '已被提取' }
    ],
    unqualifiedRegister: {
      '-1': '审核退回',
      '0': '初始'
    },
    // 采购订单状态
    purchaseOrderState: [
      { id: 0, name: '初始' },
      { id: 1, name: '审核退回' },
      { id: 2, name: '提交审核' },
      { id: 3, name: '审核通过' },
      { id: 4, name: '订单关闭' },
      { id: 5, name: '收货完成' }
    ],
    // 采购订单明细状态
    purchaseOrderDetailsState: [
      { id: 0, name: '初始' },
      { id: 1, name: '关闭' },
      { id: 2, name: '收货完成' }
    ],
    // 资料变更类型
    dataChangeType: [
      { id: 0, name: '商品' },
      { id: 1, name: '供货商' },
      { id: 2, name: '客户' }
    ],
    // 库存报损发起类型
    lomApptype: [
      { id: 0, name: '手动发起' },
      { id: 1, name: '库存盘点' }
    ],
    // 库存报溢发起类型
    ovmApptype: [
      { id: 0, name: '手动发起' },
      { id: 1, name: '库存盘点' }
    ],
    // 对方人员类型
    unitUserType: [
      { id: 0, name: '客户' },
      { id: 1, name: '供应商' }
    ],
    // 对方人员类别
    unitUserCate: [
      { id: 0, name: '业务员' },
      { id: 1, name: '提货员' },
      { id: 2, name: '收货员' }
    ],
    // 单位是否拦截
    unitIsIntercept: [
      { id: 0, name: '否' },
      { id: 1, name: '是' }
    ],
    // 委托书类别
    entrustBookCate: [
      { id: 0, name: '采购委托书' },
      { id: 1, name: '提货委托书' },
      { id: 2, name: '收货委托书' }
    ],
    // 委托书类型
    entrustBookType: [
      { id: 0, name: '单品' },
      { id: 1, name: '全品' }
    ],
    //头部任务
    webIndexHeaderCount: 0,
    // 预警页面参数
    webIndexEarlyWarningData: '',
    // OCR识别结果
    ocrMessage: null
    // isWarn: false
  },
  getters: {
    getUserInfo: state => (state.userInfo ? JSON.parse(state.userInfo) : false),
    getConfig: state =>
      state.webConfig.type == 1
        ? state.webConfig.dataOne
        : state.webConfig.dataTwo,
    getMenuList: state => (state.menuList ? JSON.parse(state.menuList) : []),
    getAllMenuList: state =>
      state.allMenuList ? JSON.parse(state.allMenuList) : [],
    getUserList: state => {
      return state.userList
    },
    // getMenuList: state => {
    //   return state.menuList
    // },
    getLeaveCategoryList: state => {
      return state.leaveCategorys
    },
    getEarlyWarningData: state => {
      //预警页面参数
      return state.webIndexEarlyWarningData
    }
    // getIsWarning: state => {	//预警页面参数
    // 	return state.isWarn
    // },
  },
  mutations: {
    updateUserInfo(state, value) {
      state.userInfo = value
    },
    updateToken(state, value) {
      state.token = value
    },
    updateMenuList(state, value) {
      state.menuList = value
      // console.log(state.menuList)
    },
    updateAllMenuList(state, value) {
      state.allMenuList = value
    },
    //更改头部任务数据
    updateWebIndexHeaderCount(state, value) {
      state.webIndexHeaderCount = value
    },
    updateWebIndexEarlyWarningData(state, value) {
      //更新预警页面信息
      state.webIndexEarlyWarningData = value
    },
    // 更新OCR识别结果
    updateOcrMessage(state, value) {
      state.ocrMessage = value
    }
    // updateIsWarn(state, value) {
    // 	state.isWarn = value
    // },
  },
  actions: {},
  modules: {}
})
